import { render, staticRenderFns } from "./PlaceOfIssue.vue?vue&type=template&id=624990e7&scoped=true"
import script from "./PlaceOfIssue.vue?vue&type=script&lang=js"
export * from "./PlaceOfIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624990e7",
  null
  
)

export default component.exports